export default "__VITE_ASSET__C3fPCye8__"